import React, { useEffect, useState } from 'react';
import { Alert, Container, Card, Button } from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import AuthService from '../../services/auth.service';

const ConfirmEmail = () => {
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [successful, setSuccessful] = useState(false);
  const { token } = useParams();

  useEffect(() => {
    if (token) {
      AuthService.confirmEmail(token)
        .then(response => {
          setMessage('Email confirmado exitosamente. Ahora puedes iniciar sesión.');
          setSuccessful(true);
          setLoading(false);
        })
        .catch(error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.detail) ||
            error.message ||
            error.toString();
          setMessage(resMessage);
          setSuccessful(false);
          setLoading(false);
        });
    } else {
      setMessage('Token de confirmación no válido');
      setSuccessful(false);
      setLoading(false);
    }
  }, [token]);

  return (
    <Container className="mt-5">
      <Card className="text-center">
        <Card.Header as="h5">Confirmación de Email</Card.Header>
        <Card.Body>
          {loading ? (
            <p>Verificando...</p>
          ) : (
            <>
              <Alert variant={successful ? 'success' : 'danger'}>
                {message}
              </Alert>
              {successful && (
                <Button as={Link} to="/login" variant="primary">
                  Ir a Iniciar Sesión
                </Button>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ConfirmEmail;